import { Divider, Grid } from '@mui/material';

export default function FormDataDivider() {
  return (
    <Grid item xs={12}>
      <Divider sx={{ mb: 2, mt: 2, borderWidth: 1 }} />
    </Grid>
  );
}
